import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { ThemeProvider } from '@gympass/yoga'

import NotFound from '@pages/NotFound'
import UnitedStatesWebsite from './websites/us'
import BrazilWebsite from './websites/br'
import UkWebsite from './websites/uk'
import MexicoWebsite from './websites/mx'

export default function Router() {
  return (
    <Switch>
      <Route path="/us">
        <ThemeProvider>
          <UnitedStatesWebsite />
        </ThemeProvider>
      </Route>

      <Route path="/br">
        <ThemeProvider>
          <BrazilWebsite />
        </ThemeProvider>
      </Route>

      <Route path="/uk">
        <ThemeProvider>
          <UkWebsite />
        </ThemeProvider>
      </Route>

      <Route path="/mx">
        <ThemeProvider>
          <MexicoWebsite />
        </ThemeProvider>
      </Route>

      <Route component={NotFound} />
    </Switch>
  )
}
